"use strict";exports.HALF_CARD_VARIANT={DEFAULT:"default",V3:"v3"};
//# sourceMappingURL=types.js.map
